import { LitElement } from 'lit';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin';
import { TriggerEventMixin } from '@common/lit/mixins/TriggerEventMixin';
import { templates } from '@src/components/templates';
import { config } from '@src/config';
import { configStore } from '@src/store';

export const BaseComponent = TemplatingMixin(
  TriggerEventMixin(LitElement, config.componentTagName),
  configStore.theme,
  templates,
);
